<template>
  <div v-if="show" class="m-dispatch-pending">
    <div class="m-dispatch-pending__qty">已派单 {{ qtyText }}</div>
    <div class="m-dispatch-pending__sub">现场核销通过、未开送货单</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { hasDispatchPendingWithoutDelivery } from '@/utils/inventoryTransactionDisplay'

const props = defineProps({
  row: { type: Object, default: null },
  fmtQty: { type: Function, required: true }
})

const show = computed(() => hasDispatchPendingWithoutDelivery(props.row))

const qtyText = computed(() => {
  const n = Number(props.row?.batch_dispatch_pending_delivery_quantity)
  return props.fmtQty(n)
})
</script>

<style scoped>
.m-dispatch-pending {
  margin-top: 4px;
  line-height: 1.35;
}
.m-dispatch-pending__qty {
  color: #e6a23c;
  font-size: 12px;
}
.m-dispatch-pending__sub {
  color: #909399;
  font-size: 11px;
}
</style>
